/** @format */

import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';

@inject('RequestsStore')
@observer
class RequestChannelSelect extends Component {
  render() {
    const { RequestsStore } = this.props;
    return (
      <div>
        <Dropdown
          value={RequestsStore.currentRequest.data.reqChannel}
          onChange={(e, selection) =>
            RequestsStore.handleReqChannelSelect(selection.value)
          }
          placeholder="Canale Richiesta"
          selection
          options={RequestsStore.requestsParams.reqChannels}
          fluid
          size="small"
        ></Dropdown>
      </div>
    );
  }
}

export default RequestChannelSelect;
